import { $ } from 'utils/dom';
import { INSTAGRAM_CREDENTIALS } from './credentials';
import unfetch from 'unfetch';

const $container = $('.o-instagram');

if ($container) {
  const $target = $('.o-instagram__items', $container);

  const run = async () => {
    try {
      const { ACCESS_TOKEN } = INSTAGRAM_CREDENTIALS;
      // List of all fields we want to get from the api
      // https://developers.facebook.com/docs/instagram-basic-display-api/reference/media#fields
      const fields = [
        'id',
        'permalink',
        'media_url',
        'thumbnail_url',
        'media_type',
        'caption',
      ];

      const endpoint = `https://graph.instagram.com/me/media?fields=${fields.join(
        ','
      )}&access_token=${ACCESS_TOKEN}`;

      const r = window.fetch ? await fetch(endpoint) : await unfetch(endpoint);
      const response = await r.json();

      const { data } = response;

      if (data) {
        const items = data.slice(0, 8).map(item => {
          const isVideo = item.media_type === 'VIDEO';

          return `
              <div class="o-instagram__item ${
                isVideo ? 'o-instagram__item--video' : ''
              }">
                <a href="${item.permalink}" target="_blank" rel="noopener">
                  <picture>
                    <img src="${
                      isVideo ? item.thumbnail_url : item.media_url
                    }" alt="${item.caption}">
                  </picture>
                </a>
              </div>
          `;
        });

        $target.innerHTML = items.join('');
      } else {
        console.error(
          'Could not load posts from Instagram. Did not receive any data.'
        );
      }
    } catch (error) {
      console.error('instagram.js: Caught error: ', error);
    }
  };

  run();
}
